import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { Loading } from 'app/ui';

import { TPermission } from '../../core/permissions';
import { getPermissionsRequest } from '../../requests/get-permissions.request';
import { RolePermissionsTransfer } from '../role-permissions-transfer/role-permissions-transfer';

type SelectValue = { id: number }[];

type AvailableRolePermissionsTransferProps = {
  value?: SelectValue;
  onChange?: (trainType: SelectValue) => void;
};

export const AvailableRolePermissionsTransfer = observer(
  ({ value, onChange }: AvailableRolePermissionsTransferProps) => {
    const [permissions, setPermissions] = useState<TPermission[]>([]);
    const errorNotify = usePageNotify();

    const getPermissionsResource = useResource<void, TPermission[]>({
      request: getPermissionsRequest,
      errorNotify: errorNotify,
      onDone(perms) {
        setPermissions(perms);
      },
    });

    const innerValue = getPermissionsResource.isLoading ? [] : value;

    const handleChange = (values: SelectValue) => {
      onChange && onChange(values);
    };

    const isLoading = getPermissionsResource.isLoading;

    useEffect(() => {
      getPermissionsResource.send();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <Loading active={isLoading}>
        <RolePermissionsTransfer
          permList={permissions}
          value={innerValue}
          onChange={handleChange}
        />
      </Loading>
    );
  },
);
